import React from 'react';
import SummaryPanel from 'components/common/SummaryPanel';
import { ICreditNotesSummaryPanel } from './SummaryPanel.properties';
import SummaryTableSchema from './SummaryTableSchema';
import { withStyles } from '@material-ui/core';
import inlineStyles from './SummaryPanel.styles';
import WarningIcon from '@markinson/uicomponents-v2/SvgIcons/Warning';
import { useRetrieveCreditNotesSummary } from 'api/creditNotes/creditNotes';

const InvalidInvoice = ({ classes }) => {
    return (
        <div className={classes.invalidInvoiceContainer}>
            Unallocated <WarningIcon className={classes.iconWarning} />
        </div>
    );
};

const StyledInvalidInvoice = withStyles(inlineStyles, { index: 1 })(InvalidInvoice) as typeof InvalidInvoice;

const updatedSchema = (schema, WorkCreditNoteId: number) => (
    SummaryTableSchema.map((node) => {
    if (!node.children) return node;

    return {
        ...node,
        children: node.children.map((child) => {
            if (child.label === 'Invoice' && (WorkCreditNoteId && !schema?.Invoice?.Value || schema?.Invoice?.Value === 'Unallocated')) {

                return {
                    ...child,
                    CustomComponent: StyledInvalidInvoice,
                    valueRenderer: {
                        ...child.valueRenderer,
                        emphasize: true,
                        hyperLink: {
                            ...child.valueRenderer.hyperLink,
                            menu: false
                        }
                    }
                };
            }

            return child;
        })
    };
})
);

const CreditNotesSummaryPanel = ({ classes }: ICreditNotesSummaryPanel) => {
    const WorkCreditNoteId = new URLSearchParams(location.search)?.get('CreditNote');
    const {data: fetchSummary} = useRetrieveCreditNotesSummary(Number(WorkCreditNoteId));

    return (
        <React.Fragment>
            <SummaryPanel
                loading={false}
                data={fetchSummary?.CreditNoteSummary?.inlineObject}
                schema={updatedSchema(fetchSummary?.CreditNoteSummary?.schema, Number(WorkCreditNoteId))}
                customClassNames={classes.poSummary}
            />
        </React.Fragment>
    );
};

export default withStyles(inlineStyles, { index: 1 })(CreditNotesSummaryPanel);
